import {
  DiscountText,
  Wrap,
} from "Components/DiscountMessage/discountMessageStyled";
import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import {
  getSelectedCriticalIllnessPrices,
  getSelectedDisabilityPrices,
  getSelectedLifePrices,
} from "./utils";

import Box from "@storeblocks/box";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { NeedName } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { sum } from "Utils/arrayUtils";
import { FormikProps } from "formik";
import React from "react";
import { usePriceFromAkaAdvice } from "../hooks/usePriceFromAkaAdvice";
import { AkaAdvicePriceFormValues } from "../interfaces";

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
}

export const AdviceTotalPrice = ({ formProps }: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const lifePrices = usePriceFromAkaAdvice(NeedName.LIFE);
  const disabilityPrices = usePriceFromAkaAdvice(NeedName.DISABILITY);
  const criticalIllnessPrices = usePriceFromAkaAdvice(
    NeedName.CRITICAL_ILLNESS,
  );

  const selectedLifePrices = getSelectedLifePrices(formProps, lifePrices);
  const selectedDisabilityPrices = getSelectedDisabilityPrices(
    isAdvisor,
    formProps,
    disabilityPrices,
  );
  const selectedCriticalIllnessPrices = getSelectedCriticalIllnessPrices(
    formProps,
    criticalIllnessPrices,
  );

  const totalPrice = selectedLifePrices
    .concat(selectedDisabilityPrices)
    .concat(selectedCriticalIllnessPrices)
    .reduce(sum, 0);

  return (
    <Box marginBottom="16px" className="AkaAdviceTotalPrice">
      <Wrap className="discount-message">
        <DiscountText>Totalpris</DiscountText>
        <NumberValue
          as="p"
          className="InsuranceMonthlyPrice"
          value={totalPrice}
          type={VALUE_TYPE.NOK_MONTH}
          boldValue
          largeValue
        />
      </Wrap>
    </Box>
  );
};
